import * as Yup from 'yup'

// TODO: change to the proper regex once we know what it should look like
const validator = /^(\w){6,14}$/

export const schema = Yup.string().matches(validator, 'Code is invalid')

export const getIsValidTestTubeCode = (code: string) => schema.isValidSync(code)
